
import { getID } from "src/libs/utilities";
import { IPanel, IPanelConsole } from "../interface";
import { usePanelStore } from "../store";

export default function doShoWPanelData (panelKey:string, isDefaultFloat: boolean = true ): boolean {
    const state     = usePanelStore.getState()
    let newPanel    = state.panels.find((( panel: IPanel ) => panel.panelDatas.find(pd => pd.id === panelKey) ))
    if( !newPanel ) { 
        if(isFloatPanelData(panelKey)) {
            const float = state.float.map((panel:IPanel) => {
                if(panel.panelDatas.find(pd => pd.id === panelKey)) {
                    return {...panel, activeId: panelKey}
                }
                return panel
            })
            usePanelStore.setState({ float, })
        }
        else if(isConsolePanelData(panelKey)) { 
            const consoles = state.consoles.map((console: IPanelConsole) => {
                return {
                    ...console,
                    panels: console.panels.map(panel => {
                        if(panel.panelDatas.find(pd => pd.id === panelKey)) {
                            return {...panel, activeId: panelKey}
                        }
                        return panel
                    })
                }
            })
            usePanelStore.setState({ consoles, })
        }
        return false
    }
    const panels    = state.panels.filter(( panel: IPanel ) => panel.id !== newPanel.id) 
    newPanel        = {
        ...newPanel,
        activeId: panelKey
    } 
    if( !newPanel.isTread ) {
        const float = [ ...state.float, newPanel ]
        usePanelStore.setState({ float, panels })
        return true
    }
    else {
        const consoles = [...state.consoles]
        if(!consoles.length){
            consoles.push({
                id : getID("console"),
                panels: [],
                width: 300
            })
        } 
        consoles[0].panels.push( newPanel )
        usePanelStore.setState({ consoles, panels })
        return true
    }
}

export function isFloatPanelData(panelKey:string): boolean {
    const state     = usePanelStore.getState()
     
    return !!state.float.filter((( panel: IPanel ) => panel.panelDatas.find(pd => pd.id === panelKey) )).length 
}

export function isConsolePanelData(panelKey:string): boolean {
    const state     = usePanelStore.getState()
     
    return !!state.consoles.find((console: IPanelConsole) => console.panels.find((( panel: IPanel ) => panel.panelDatas.find(pd => pd.id === panelKey) )) || false)
}